module.exports = "/_next/static/images/barcode-76e37848ee2ff5ded0e30f4477f7ad27.svg";